export const BASE_URL =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_UI_URL : 'http://localhost:3000';
